export * as Api from './api';

export enum SignatureType {
  PlainText = 'PLAIN_TEXT',
}

export interface KiFundCertificate {
  kiFundCertificatesBatchId: string;
  investorId: string;
}

export interface KiFundCertificatesBatch {
  _id: string;
  fundId: string;
  fundReferenceNumber: string;
  fundManagerAddress: {
    address1: string;
    address2?: string | null;
    city: string;
    postcode: string;
    country: string;
  };
  fundManagerSignatoryName: string;
  capicityInWhichSigned: string;
  signatureDate: string;
  signatureType: SignatureType;
}
